<template>
  <div>
    <eb-card-two>
      <div class="card-header">
        <div class="card-header-left ellipsis">
          <router-link :to="'/supplier/detail/'+ orgInfo.departId">
          {{orgInfo.departName}}
          </router-link>
          <ebFontType v-if="orgInfo.authStatus === '1'">
            <span>实</span>
          </ebFontType>
        </div>
        <div id="ebShare" class="card-header-right">
          <span>分享</span>
          <i class="icon iconfont icon-fenxiang"></i>
          <span>关注</span>
          <i v-if="orgInfo.isFollow != '0'" @click="followCompany" class="icon iconfont icon-wujiaoxing"></i>
          <i v-else @click="followCompany" class="icon iconfont icon-wujiaoxing-red"></i>
          <el-button v-if="orgInfo.isSupplier != '1'" @click="showAddSupplierDialog" class="eb-button-red eb-button-small">添加供应商</el-button>
          <el-button v-else @click="showEditSupplierDialog" class="eb-button-red eb-button-small">修改供应商</el-button>
        </div>
      </div>
      <div class="card-body">
        <div class="card-body-left">
          <template v-if="orgInfo.departLogo">
            <img :src="orgInfo.departLogo">
          </template>
          <template v-else>
            <img :src="$ebConfig.imgPath+'img/project-default.jpg'">
          </template>
        </div>
        <div class="card-body-right">
          <div class="card-two-row">
            <div class="col-165-rw">
              <div class="col-left">级&emsp;&emsp;别:</div>
              <div class="col-right">
                <span class="col-right-content"> {{orgInfo.companyLevel | companyLevel}}</span>
              </div>
            </div>
            <div class="col-261-rw">
              <div class="col-left">编&emsp;&emsp;号:</div>
              <div class="col-right">
                <span class="col-right-content"> {{orgInfo.supplierCode}}</span>
              </div>
            </div>
            <div class="col-165-rw">
              <div class="col-left">历史合作:</div>
              <div class="col-right">
                <span class="col-right-content"> {{orgInfo.cooperationTimes}}</span>
              </div>
            </div>
            <div class="col-220-rw">
              <div class="col-left">历史评价:</div>
              <div class="col-right">
                <span class="col-right-content"> 好 {{orgInfo.goodCount}} 中{{orgInfo.mediumCount}} 差{{orgInfo.badCount}}</span>
              </div>
            </div>
          </div>
          <div class="card-two-row">
            <div class="col-165-rw">
              <div class="col-left">注册资本:</div>
              <div class="col-right">
                <span class="col-right-content"> {{orgInfo.registerCapital}}</span>
              </div>
            </div>
            <div class="col-261-rw">
              <div class="col-left">联&ensp;系&ensp;人:</div>
              <div class="col-right">
                <template v-for="(item, $index) in orgInfo.contacts">
                  <template v-if="item.headImg">
                    <img :key="$index" @click="userInfoDialog(item.userId)" class="header_img" :src="headImgSrc(item.headImg)">
                  </template>
                  <template v-else>
                    <img :key="$index" @click="userInfoDialog(item.userId)" class="header_img" :src="$ebConfig.imgPath+'img/user-default.jpeg'">
                  </template>
                </template>
              </div>
            </div>
            <div class="col-410-rw">
              <div class="col-left">地&emsp;&emsp;址:</div>
              <div class="col-right">
                <span class="col-right-content"> {{orgInfo.registerAddress}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </eb-card-two>
    <SupplierOwnEdit @addSupplierSuccess="onSuccess" :isVisible.sync="dialogVisible" :mySupplierInfo="orgSupplierInfo" />
  </div>
</template>

<script>
import SupplierOwnEdit from '@/components/supplier/SupplierOwnEdit';
import ebCardTwo from '@/components/common/card/eb-card-two';
import ebFontType from '@/components/common/eb-font-type';
import eventBus from '@/plugins/event-bus';
import { followCompany } from '@/services/user/user-supplier-service';
import { baseURL } from '@/plugins/axios';
export default {
  props: {
    orgInfo: {
      type: Object
    }
  },
  data() {
    return {
      dialogVisible: false,
      orgSupplierInfo: {
        dialogVisible: false,
        operType: 'add',
        supplierId: null,
        supplierDepartName: null,
        supplierCode: null,
        companyLevel: null,
        purchaseLabel: null
      }
    };
  },
  components: {
    ebCardTwo,
    ebFontType,
    SupplierOwnEdit
  },
  methods: {
    userInfoDialog: function(userId) {
      eventBus.$emit('userInfoDialog', userId);
    },
    // 显示弹出窗口
    showAddSupplierDialog: function() {
      this.dialogVisible = true;
      this.orgSupplierInfo.operType = 'add';
      this.orgSupplierInfo.departId = this.orgInfo.departId;
      this.orgSupplierInfo.departName = this.orgInfo.departName;
      this.orgSupplierInfo.supplierCode = null;
      this.orgSupplierInfo.companyLevel = null;
      this.orgSupplierInfo.purchaseLabel = null;
    },
    // 显示修改弹出框口
    showEditSupplierDialog: function() {
      this.dialogVisible = true;
      this.orgSupplierInfo.operType = 'edit';
      this.orgSupplierInfo.departId = this.orgInfo.departId;
      this.orgSupplierInfo.departName = this.orgInfo.departName;
      this.orgSupplierInfo.userSupplierId = this.orgInfo.userSupplierId;
      this.orgSupplierInfo.buyerId = this.orgInfo.buyerId;
      this.orgSupplierInfo.supplierCode = this.orgInfo.supplierCode;
      this.orgSupplierInfo.companyLevel = this.orgInfo.companyLevel === 4 ? null : this.orgInfo.companyLevel;
      this.orgSupplierInfo.purchaseLabel = this.orgInfo.purchaseLabel;
    },
    // 关注或取消关注
    async followCompany() {
      this.$root.layout.isLoading = true;
      this.orgSupplierInfo.companyId = this.orgInfo.departId;
      try {
        let { data } = await followCompany(this.orgSupplierInfo.companyId);
        if (data.returnCode === '01') {
          this.$message.success('操作成功');
          this.$emit('addSupplierSuccess');
        } else if (data.returnCode === '00') {
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    onSuccess: function() {
      this.$emit('addSupplierSuccess');
    }
  },
  computed: {
    headImgSrc() {
      return function(headImg) {
        return baseURL + headImg + '?time=' + Date.now();
      };
    }
  }
};
</script>

<style scoped lang="less">
#ebShare {
  display: flex;
  i {
    color: #fb5b3b;
    font-size: 18px;
    margin: 0 7px 0 5px;
  }
}
.card-header {
  display: flex;
}
.card-header-left {
  width: 75%;
  height: 52px;
  display: flex;
  font-weight: 700;
  font-family: 'Microsoft YaHei';
  align-items: center;
  a{
    color: #060606;
  }
}
.card-header-right {
  width: 25%;
  height: 52px;
  display: flex;
  align-items: center;
  line-height: 22px;
  padding-right: 1.3%;
}
.card-body {
  display: flex;
}
.card-body-left {
  height: 95px;
  width: 14%;
  display: flex;
  img {
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.card-body-right {
  width: 84%;
  padding-left: 2%;
}
.header_img {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin-top: 8px;
  cursor: pointer;
}
.departName {
  cursor: pointer;
  max-width: 93%;
  display: inline-block;
  padding-right: 10px;
}
.icon-wujiaoxing,.icon-wujiaoxing-red{
  cursor: pointer;
}
</style>
